'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.langs = [];
  }

  $onInit() {
    this.getList();
    this.getCategories();
  }

  getCategories() {
    this.$http.get(`/api/categories/${this.$stateParams.id}`)
      .then(res => {
        this.category = res.data;
        if (this.category.langs) {
          this.langs = Object.entries(this.category.langs);
        }
      });
  }

  save() {
    this.langs.forEach(lang => {
      if (!this.category.langs) {
        this.category.langs = {};
      }
      this.category.langs[lang[0]] = lang[1];
    });

    this.$http.put(`/api/categories/${this.category._id}`, this.category).then(res => {
      this.$state.go('categories');
    });
  }

  addLang() {
    this.langs.push(new Array(2));
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.category.modelGroups.indexOf(id);
    if (idx > -1) {
      this.category.modelGroups.splice(idx, 1);
    } else {
      this.category.modelGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/categories/edit/edit.controller.js